module.exports = __webpack_public_path__ + "img/millfields_rd_b1.b45a2ba8.jpg";